import { useState } from "react";
import Box from "@mui/material/Box";
import ModalBasicLayout from "./ModalBasicLayout";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_USAGE_GUIDE } from "../../i18n/keysTranslations";

const VIDEO_ASPECT_RATIO = 1920 / 1048;

const ModalWatchGuideVideo = ({ modalOpen, onCloseModal, videoUrl }) => {
  const { t } = useTranslationApp();
  const [aspectRatio, setAspectRatio] = useState(VIDEO_ASPECT_RATIO);
  const frameWidth = `min(calc(100vw - 48px), calc((100vh - 96px) * ${aspectRatio}))`;

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={false}
      maxWidth={false}
      scroll="paper"
      ariaLabel={t(TEMPLATES_USAGE_GUIDE)}
      sxTitle={{
        px: 0,
        pt: 0,
        pb: 1,
        mb: 0,
        minHeight: 0,
      }}
      sxContent={{
        p: 0,
        overflow: "hidden",
      }}
      sx={{
        "& .MuiDialog-paper": {
          width: frameWidth,
          maxWidth: frameWidth,
          height: "auto",
          maxHeight: "none",
          m: 0,
          overflow: "visible",
          borderRadius: 2,
          backgroundColor: "transparent",
          backgroundImage: "none",
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          borderRadius: "1.2% / 2.4%",
          lineHeight: 0,
        }}
      >
        <Box
          component="video"
          key={videoUrl}
          src={videoUrl}
          controls
          autoPlay
          playsInline
          onLoadedMetadata={(event) => {
            const { videoWidth, videoHeight } = event.currentTarget;
            if (videoWidth > 0 && videoHeight > 0) {
              setAspectRatio(videoWidth / videoHeight);
            }
          }}
          sx={{
            display: "block",
            width: "100%",
            height: "auto",
            aspectRatio: String(aspectRatio),
            objectFit: "fill",
            backgroundColor: "transparent",
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalWatchGuideVideo;
